import { makeRequest } from 'utils/requestLogger';

// This endpoint deletes students submissions and denies them access to the Roudntable.
// Students are kicked out
export default (roundtableId, payload) =>
    makeRequest(
        'post',
        `/api/roundtables/${roundtableId}/remove-students`,
        payload
    );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/removeStudents.js